// export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000': ''

export const BASE_URL = ''
export const PRODUCTS_URL = '/api/products'
export const USERS_URL = '/api/users'
export const ORDERS_URL = '/api/orders'
export const UPLOAD_URL = '/api/upload'


export const availableLanguages = [
  "English (US)",
  "English (UK)",
  "French",
  "Spanish",
  "German",
  "Arabic",
  "Italian",
  "Dutch",
  "Dariya (Morocco)",
];

export const languageFlags = {
  'English (US)': 'https://flagcdn.com/us.svg',
  'English (UK)': 'https://flagcdn.com/gb.svg',
  'French': 'https://flagcdn.com/fr.svg',
  'Spanish': 'https://flagcdn.com/es.svg',
  'German': 'https://flagcdn.com/de.svg',
  'Arabic': 'https://flagcdn.com/sa.svg',
  'Italian': 'https://flagcdn.com/it.svg',
  'Dutch': 'https://flagcdn.com/nl.svg',
  'Dariya (Morocco)': 'https://flagcdn.com/ma.svg',
};


export const banners = [
  {
    image: "/banners/banner1.png",
    mobileImage: "/banners/banner1mp.png",
    width: 1672, height: 941, mobileWidth: 1122, mobileHeight: 1402,
    alt: "Explore emotion regulation activities",
    buttonName: "Explore emotion regulation activities",
    buttonLink: "/search/emotion%20regulation",
  },
  {
    image: "/banners/banner2.png",
    mobileImage: "/banners/banner2mp.png",
    width: 1672, height: 941, mobileWidth: 1122, mobileHeight: 1402,
    alt: "Explore social skills activities",
    buttonName: "Explore social skills activities",
    buttonLink: "/search/social%20skills",
  },
  {
    image: "/banners/banner3.png",
    mobileImage: "/banners/banner3mp.png",
    width: 1659, height: 948, mobileWidth: 1122, mobileHeight: 1402,
    alt: "Explore semantics activities",
    buttonName: "Explore semantics activities",
    buttonLink: "/search/semantics",
  },
  {
    image: "/banners/banner4.png",
    mobileImage: "/banners/banner4mp.png",
    width: 1677, height: 938, mobileWidth: 1122, mobileHeight: 1402,
    alt: "Explore syntax activities",
    buttonName: "Explore syntax activities",
    buttonLink: "/search/syntax",
  }
];




